var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.996 1C15.3259 1 1 15.3245 1 32.996C1 50.6676 15.3259 64.992 32.996 64.992C50.6662 64.992 64.992 50.6676 64.992 32.996C64.992 15.3245 50.6662 1 32.996 1ZM32.996 1C15.3259 1 1 15.3245 1 32.996C1 50.6676 15.3259 64.992 32.996 64.992C50.6662 64.992 64.992 50.6676 64.992 32.996C64.992 15.3245 50.6662 1 32.996 1ZM32.996 1C15.3259 1 1 15.3245 1 32.996C1 50.6676 15.3259 64.992 32.996 64.992C50.6662 64.992 64.992 50.6676 64.992 32.996C64.992 15.3245 50.6662 1 32.996 1Z",
    fill: "white",
    stroke: "#625E5E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0878 35.4811L26.8368 45.6373C26.509 45.8436 26.1345 45.9468 25.7615 45.9468C25.4223 45.9468 25.0831 45.862 24.7765 45.691C24.1307 45.3335 23.7294 44.6538 23.7294 43.9147V23.6009C23.7294 22.8619 24.1307 22.1822 24.7765 21.8246C25.4209 21.4643 26.2108 21.4869 26.8368 21.8783L43.0878 32.0359C43.6828 32.4076 44.0431 33.0576 44.0431 33.7585C44.0431 34.458 43.6828 35.1095 43.0878 35.4811Z",
    fill: "#625E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic_play.78a9dba3721a4839f969b7d33bc508ca.svg";
export { ForwardRef as ReactComponent };